module.exports = __webpack_public_path__ + "img/logo-large.609b2467.png";